<template>
  <div class="fastPayment">
    <!-- 搜索 -->
    <div class="search_bar">
      <van-search
        v-model="listQuery.buyer_name"
        show-action
        placeholder="请输入买家姓名进行搜索"
        @search="onSearch"
      >
        <template slot="action">
          <div @click="onSearch"> 搜 索 </div>
        </template>
      </van-search>
    </div>
    <!-- 欠款统计 -->
    <div >

    </div>
    <!-- 列表 -->
    <div class="list">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="min-height:100%">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getList"
            >
            <div class="item" v-for="(item,index) in list" :key="index" @click="$route.query.id?'':toBuyerDetail(item)">
                <div class="item_1">
                    <div class="item_title van-ellipsis">
                        {{item.buyer_name}}
                    </div>
                    <div class="item_date">
                      <span>欠款：</span><span class="item_price">{{item.debts}}元</span><span></span>
                    </div>
                </div>
                <div class="item_2" @click.stop="handlePaymant(item)">
                  还款
                </div>
            </div>
            <div style="height:0.5rem"></div>
            </van-list>
        </van-pull-refresh>
    </div>

    <!-- 选择还款方式 -->
    <van-action-sheet
      title="选择还款方式"
      v-model="actionSheetShow"
      :actions="actions"
      :close-on-popstate="true"
      :close-on-click-action="true"
      cancel-text="取消"
      @cancel="onCancel"
      @select="onSelect"
    />
  </div>
</template>

<script>
import {credit_list} from "@/api/work/credit/credit"
export default {
  name: 'fastPayment',
  data(){
    return {
      actions: [
        { name: '选择订单还款' },
        { name: '直接还款', subname: '不选择订单，按欠款总金额还款' },
      ],
      list: [],
      loading: true,
      finished: true,
      refreshing: false,
      listQuery:{
          page:1,
          pageSize:'15',  
          buyer_name:''
      },

      actionItem:"",
      actionSheetShow:false
    }
  },
  created(){
    this.getList()
    this.$navigation.on('back', (to, from) => {
      if(to.route.name == 'credit_fastPayment'){
        this.getList()
      }
    })
  },
  mounted(){




  },
  methods:{
    // 点击了搜索按钮
    onSearch(){
      // this.$toast(this.listQuery.search)
      this.getList()
    },

    
    // 获取列表
    getList(){
      credit_list(this.listQuery).then(res=>{
        if(res.code == 200 ){
            this.list = res.data.buyer
            this.finished = true;
            this.loading = false
            this.refreshing = false;
        }
      })
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      // this.finished = false;
      this.refreshing = true;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.listQuery.page = 1
      this.getList();
    },

    // 点击了还款
    handlePaymant(item){
      this.actionItem = JSON.stringify(item)
      this.actionSheetShow = true ;
    },
    // 点击了选项
    onSelect(action,index){
      if(index== 0){
        // 选择订单还款
        this.$router.push({
          path: "/credit/fastPaymentOrder",
          query:{
            item:encodeURI(this.actionItem)
          }
        });
      }else{
        this.$router.push({
          path: "/credit/payment",
          query:{
            type:2,
            item:encodeURI(this.actionItem)
          }
        });
      }
    },

    // 点击了还款取消
    onCancel() {
      this.actionSheetShow = false;
    },

    
    // 去订单补录
    toAddCAredit() {
      this.$router.push({
        path: "/credit/addCredit"
      });
    },
    
    // 去买家详情
    toBuyerDetail(item){
      this.$router.push({
        path: "/manage/buyer/buyerDetail",
        query:{
          id:item.buyer_id
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.fastPayment{
  position: relative;
  .search_bar{
    position: sticky;
    top: 0.88rem;
    z-index: 2;
    box-shadow: 0 0 0.05rem 0.05rem #f1f1f1;
  }
  .list{
    position: relative;
    .item{
      margin: 0.2rem 0.3rem 0;
      border-radius: 0.1rem;
      background-color: #fff;
      height: 1.3rem;
      box-sizing: border-box;
      // padding:0 0.2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.28rem;
      overflow: hidden;
      .item_1{
        box-sizing: border-box;
        width: 5.5rem;
        padding-left: 0.2rem;
        .item_title{
          font-size: 0.34rem;
          font-weight: 500;
        }
        .item_date{
          color: #999999;
          margin-top: 0.05rem;
        }
        .item_price{
          color:#EF9B2F;
        }
      }
      .item_2{
        width: 1.3rem;
        background-color: #31B158;
        color:#fff;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
        line-height: 1.3rem;
        letter-spacing: 0.02rem;
      }
    }
  }
}
</style>

<style lang="less">
.fastPayment{
  .van-action-sheet__item{
    color: #31B158;
  }
}
</style>